import React from 'react';

const ReviewQueueFilters = ({
  customers,
  selectedCustomerId,
  onCustomerChange,
  loading,
  hideCustomerFilter = false
}) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="row g-3">
          {!hideCustomerFilter && (
            <div className="col-md-6">
              <label htmlFor="customerFilter" className="form-label">
                Customer
              </label>
              <select
                id="customerFilter"
                className="form-select"
                value={selectedCustomerId}
                onChange={(e) => onCustomerChange(e.target.value)}
                disabled={loading}
              >
                <option value="">All Customers</option>
                {customers.map((customer) => (
                  <option key={customer.id} value={customer.id}>
                    {customer.customerName}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewQueueFilters;
